import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { CloneProjectModeEnum } from '../CloneProjectModeEnum'
import type { Project } from '../Project'

@InputType()
export class CloneProjectArgs extends ActionArgs {
  @Field(() => ID)
  sourceProjectId: string

  @Field(() => CloneProjectModeEnum)
  mode: CloneProjectModeEnum

  @Field(() => Boolean, { defaultValue: false })
  copyTasks: boolean

  @Field(() => Boolean, { defaultValue: false })
  copyAssets: boolean
}

export interface ICloneProject extends IAction<Project, CloneProjectArgs> {}
